<template>
  <page
    :name="$t('Trasferimenti')"
    :state="[productsState]"
    :empty="!hostingTransfer.length && !registrantData.length"
    :empty-text="$t('Nessun trasferimento in attesa di dati')"
  >
    <template #header>
      {{ $t('In questa pagina puoi comunicarci i dati per procedere con i trasferimenti di siti, posta e domini') }}
    </template>

    <pf-page-section>
      <pf-card v-if="hostingTransfer.length > 0">
        <pf-card-header>
          <pf-card-title>
            <pf-title h="3">{{ $t('Trasferimenti di siti e email') }}</pf-title>
            <pf-helper-text>
              <pf-helper-text-item variant="warning" icon>
                {{ $t('Per poter procedere con il trasferimento di questi servizi ci occorrono alcuni dati') }}
              </pf-helper-text-item>
            </pf-helper-text>
          </pf-card-title>
        </pf-card-header>
        <pf-card-body>
          <pf-data-list expandable>
            <pf-data-list-item v-for="product in hostingTransfer" :key="product.id">

              <pf-data-list-cell>
                {{ $t('Inserisci i dati per il trasferimento dei servizi associati al dominio: {0}', [product.dominio]) }}
              </pf-data-list-cell>

              <pf-data-list-content>
                <form-hosting-transfer
                  :hosting="product"
                  :ask-site-transfer="product.missing_data"
                  :ask-mail-transfer="product.missing_mail_data"
                  @submit="productsState.update"
                />
              </pf-data-list-content>
            </pf-data-list-item>
          </pf-data-list>
        </pf-card-body>
      </pf-card>

      <pf-card v-if="registrantData.length > 0">
        <pf-card-header>
          <pf-card-title>
            <pf-title h="3">{{ $t('Trasferimenti di domini in attesa') }}</pf-title>
            <pf-helper-text>
              <pf-helper-text-item variant="warning" icon>
                {{ $t('Per completare la registrazione o il trasferimento di questi nomi a dominio ci occorrono alcuni dati') }}
              </pf-helper-text-item>
            </pf-helper-text>
          </pf-card-title>
        </pf-card-header>
        <pf-card-body>
          <pf-data-list expandable>
            <pf-data-list-item v-for="product in registrantData" :key="product.id" >
              <pf-data-list-cell>
                {{ $t('Inserisci i dati per il trasferimento del dominio: {0}', [product.dominio]) }}
              </pf-data-list-cell>

              <pf-data-list-content>
                <form-domain-registrant
                  :domain="product"
                  @submit="productsState.update"
                />
              </pf-data-list-content>
            </pf-data-list-item>
          </pf-data-list>
        </pf-card-body>
      </pf-card>
    </pf-page-section>
  </page>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { ProductOrdersResource, type ProductOrder } from '@/resources';
import FormDomainRegistrant from '../components/form-domain-registrant.vue';
import FormHostingTransfer from '../components/form-hosting-transfer.vue';
import { asyncComputedList } from '@common/asyncComputed';

const { state: productsState, result: products } = asyncComputedList(() => new ProductOrdersResource({ missing_data: '1' }).get());
type MissingDataProductOrder = Omit<ProductOrder, 'dominio'> & {dominio: string};

const registrantData = computed(() => {
  const domains: MissingDataProductOrder[] = products.value.filter(p => p.missing_data && p.registrazione_dominio && p.dominio !== null) as MissingDataProductOrder[];

  return domains;
});

const hostingTransfer = computed(() => {
  const hosting: MissingDataProductOrder[] = products.value.filter( p => (p.missing_data && p.ask_site_transfer || p.missing_mail_data && p.ask_mail_transfer) && p.dominio !== null) as MissingDataProductOrder[];

  return hosting;
});

</script>
